"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const TabBar = ({ children, containerStyle }) => {
    const container = Object.assign({ height: 56, width: '100%', display: 'flex', justifyContent: 'space-evenly' }, containerStyle);
    return React.createElement("div", { style: container }, children);
};
exports.default = TabBar;
